import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: {
    branding: {
      logo: "",
      companyName: "Silver Fort",
      tagline: "Leading the future of business solutions",
      heroBackground: "",
    },
    socialMedia: {
      facebook: "",
      twitter: "",
      linkedin: "",
      instagram: "",
      youtube: "",
      tiktok: "",
      snapchat: "",
      pinterest: "",
      telegram: "",
      whatsapp: "",
      discord: "",
    },
    contact: {
      email: "info@silverfort.com",
      phone: "+1 (555) 123-4567",
      address: "123 Business Street, City, State 12345",
      whatsapp: "",
      website: "https://silverfort.com",
    },
    aboutUs: {
      title: "About Us",
      description:
        "We are a leading company dedicated to providing innovative solutions and exceptional service to our clients worldwide.",
      images: [],
    },
    specialOffers: [],
  },
  loading: false, // RTK Query handles loading state, this is just for initial state
};

const homepageSlice = createSlice({
  name: "homepage",
  initialState,
  reducers: {
    setSettings: (state, action) => {
      state.settings = action.payload;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setSettings, setLoading } = homepageSlice.actions;

// Selectors
export const selectSettings = (state) => state.homepage.settings;
export const selectHomepageLoading = (state) => state.homepage.loading;

export default homepageSlice.reducer;
